import { render } from "./Primary.vue?vue&type=template&id=33254e0c&ts=true"
import script from "./Primary.vue?vue&type=script&lang=ts"
export * from "./Primary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__